/** Разбор адреса обозревателя референсов: вид, открытая папка модели, площадки (чистая логика). */
import type { SiteLevel } from "../../../lib/sites";
import { siteLevel } from "../../../lib/sites.ts";

export type BrowserView = "folders" | "photos" | "sites";

type Params = { get(name: string): string | null };

/**
 * `sitesOn` — доступен третий вид; `hasModels` — у строк есть модели (иначе папок нет).
 * Модель читается только в «папках», номер площадки — только в «площадках».
 */
export function parseBrowserView(
  params: Params,
  sitesOn: boolean,
  hasModels: boolean,
): { view: BrowserView; modelKey: string | null; level: SiteLevel; siteNumber: number | null } {
  const view: BrowserView =
    sitesOn && params.get("view") === "sites"
      ? "sites"
      : hasModels && params.get("view") !== "photos"
        ? "folders"
        : "photos";
  const modelKey = view === "folders" ? params.get("model") : null;
  const level = siteLevel(params);
  const siteParam = view === "sites" ? Number(params.get("site")) : NaN;
  const siteNumber = Number.isInteger(siteParam) && siteParam > 0 ? siteParam : null;
  return { view, modelKey, level, siteNumber };
}
